import axios from 'axios';
import { API_CONSULTA_URL, API_URL } from '../config/constants';

class BaseService {
    constructor(route) {
        this.route = route;
        this.headers = [];
    }

    setHeader(header) {
        this.headers = header;
    }

    async get(id) {
        if(id){
            const res = await axios.get(`${API_URL}${this.route}/${id}`);
            return res.data;
        } else {
            const res = await axios.get(`${API_URL}${this.route}`);
            return res.data;
        }
    }

    
    async put(id, body) {
        const res = await axios.put(`${API_URL}${this.route}/${id}`, body);
        return res.data;
    }
    
    
    async post(body) {
        const res = await axios.post(`${API_URL}${this.route}`, body);
        return res.data;
    }

    async delete(id) {
        const res = await axios.delete(`${API_URL}${this.route}/${id}`);
        return res.data;
    }

    async getListRoute(skip=0, limit=99999, params={sort:null}) {
        const res = await axios.get(`${API_URL}${this.route}?skip=${skip}&limit=${limit}&sort=${params.sort}`);
        return res.data;
    }

    //Generics
    async _get (routeAdd) {
        const res = await axios.get(`${API_URL}${routeAdd}`,{
            validateStatus: function (status) {
              return true;
            },
          });
        return res.data;
    }

    async _getBlob (routeAdd, archiveName) {
        await axios.get(`${API_URL}${routeAdd}`, {
            responseType: 'blob'
        }).then(response => {
            const url = URL.createObjectURL(response.data);

            // Criar um link para iniciar o download
            const link = document.createElement('a');
            link.href = url;
            link.download = true;
            link.click();

            // Liberar o URL temporário
            URL.revokeObjectURL(url);
        }).catch(error => {
            console.error('Erro ao fazer o download:', error);
            return 'Erro ao fazer download';
        });
    }


    async _getOne (routeAdd) {
        const res = await axios.get(`${API_URL}${routeAdd}`);
        const {data:{rows}} = res;
        return rows.length > 0 ? rows[0] : null;
    }
    async _put(routeAdd, body) {
        const res = await axios.put(`${API_URL}${routeAdd}`, body,{
            validateStatus: function (status) {
              return true;
            },
          });
        return res.data;
    }

    async _post(routeAdd, body) {
        const res = await axios.post(`${API_URL}${routeAdd}`, body,{
            validateStatus: function (status) {
              return true;
            },
          });
        return res.data;
    }

    async _postConsulta(routeAdd, body) {
        const payloadToken = {code:routeAdd,body};
        const resToken = await axios.post(`${API_URL}consulta/temp-token`,payloadToken);
        const res = await axios.post(`${API_CONSULTA_URL}${routeAdd}`, body,{
            validateStatus: function (status) {
              return true;
            },
            headers:{
                authorization:resToken.data.token,
                "x-portal": 1
            }
          });
        return res.data;
    }

    async _postWithTimeout(routeAdd, body, timeout) {
        const res = await axios.post(`${API_URL}${routeAdd}`, body, {
            timeout: timeout
        }).then(response => {
            return response.data;
        }).catch(error => {
            
            return {
                error: true,
                retorno: {
                    msg: 'Tempo esgotado para sua requisição, refine melhor sua busca'
                }
            }
        });

        return res;
    }

    async _postConsultaWithTimeout(routeAdd, body, timeout) {
        const payloadToken = {code:routeAdd,body};
        const resToken = await axios.post(`${API_URL}consulta/temp-token`,payloadToken);
        const res = await axios.post(`${API_CONSULTA_URL}${routeAdd}`, body, {
            timeout: timeout,
            validateStatus: function (status) {
                return true;
              },
            headers:{
                authorization:resToken.data.token,
                "x-portal": 1
            }
        }).then(response => {
            return response.data;
        }).catch(error => {
            
            return {
                error: true,
                retorno: {
                    msg: 'Tempo esgotado para sua requisição, refine melhor sua busca'
                }
            }
        });

        return res;
    }

    async _delete(routeAdd) {
        const res = await axios.delete(`${API_URL}${routeAdd}`);
        return res.data;
    }

}

export default BaseService;